const roadsideAsssistanceLinks = [
    {
      label: "1-877-762-3101",
      url: "tel:1-877-762-3101",
    },
  ];
  
  const roadsideAssistance = { heading: "Roadside Assistance", links: roadsideAsssistanceLinks };
  
  export {roadsideAssistance};